import map from "lodash/map";
import size from "lodash/size";
import reject from "lodash/reject";

const Notification = (app) => {
  app
    .get("/notification/read/:notification", async ({ req, res, api }) => {
      await api("notification", {
        method: "POST",
        body: { notifications: [req.params.notification] },
      });
      res.backDontScroll();
    })
    .post("/notification/read/:notification", async ({ req, res, api }) => {
      const { redirectPath } = req.body;
      await api("notification", {
        method: "POST",
        body: { notifications: [req.params.notification] },
      });
      res.redirect(redirectPath);
    })
    .get(
      "/notification/read-all",
      async ({ req, res, api, load, locals, flash }) => {
        await load("listNotifications", {
          limit: 5,
        });
        const { listNotifications } = locals;

        const unread = reject(listNotifications, "read");

        if (size(unread)) {
          await api("notification", {
            method: "POST",
            body: { notifications: map(unread, "_id") },
          });
          flash("success", `Successfully marked as read`);
          res.backDontScroll();
        } else {
          flash("success", `Selected notifications are already read`);
          res.backDontScroll();
        }
      }
    )
    .post(
      "/notification/coach-notifications/read",
      async ({ assert, req, res, api, flash }) => {
        const { notifications } = req.body;

        assert(
          notifications?.length,
          400,
          "Selected notifications are already read"
        );

        await api("notification", {
          method: "POST",
          body: { notifications: notifications },
        });

        flash("success", `Successfully marked as read`);

        res.refreshWith({ page: 0 }, { url: "back", hash: "#_" });
      }
    );
};

export default Notification;
